var _path, _path2, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 40,
    viewBox: "0 0 48 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.44263 18.7666C9.44263 9.91119 15.9336 2.73242 23.9407 2.73242C31.9477 2.73242 38.4387 9.91119 38.4387 18.7666C38.4387 26.8758 32.9956 33.579 25.9296 34.6511C25.4343 33.2927 24.2311 32.334 22.8254 32.334C20.9777 32.334 19.4797 33.9906 19.4797 36.0342C19.4797 38.0777 20.9777 39.7344 22.8254 39.7344C24.3297 39.7344 25.6021 38.6364 26.0232 37.1256C31.106 36.4275 35.4814 33.2078 38.094 28.6338H39.554C43.8654 28.6338 47.3606 24.7683 47.3606 20C47.3606 15.2317 43.8654 11.3662 39.554 11.3662H39.2772C36.6958 4.832 30.8004 0.265625 23.9407 0.265625C17.0809 0.265625 11.1855 4.832 8.60413 11.3662H8.32739C4.0159 11.3662 0.520752 15.2317 0.520752 20C0.520752 24.7683 4.0159 28.6338 8.32739 28.6338H9.83977L9.84341 28.6386H10.9689C11.6274 28.6386 12.0343 27.9203 11.6957 27.3554C10.2691 24.8733 9.44263 21.9286 9.44263 18.7666Z",
    fill: "#EC187B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6349 24.7673L17.1138 24.911L17.1968 24.6345L16.9988 24.4244L16.6349 24.7673ZM15.0188 30.1543L14.5399 30.0106L14.1787 31.2146L15.2682 30.5877L15.0188 30.1543ZM20.1704 27.1897L20.3583 26.7264L20.1324 26.6347L19.921 26.7563L20.1704 27.1897ZM33.4778 17.8848C33.4778 23.152 29.2079 27.4219 23.9407 27.4219V28.4219C29.7602 28.4219 34.4778 23.7043 34.4778 17.8848H33.4778ZM23.9407 8.34766C29.2079 8.34766 33.4778 12.6176 33.4778 17.8848H34.4778C34.4778 12.0653 29.7602 7.34766 23.9407 7.34766V8.34766ZM14.4036 17.8848C14.4036 12.6176 18.6735 8.34766 23.9407 8.34766V7.34766C18.1212 7.34766 13.4036 12.0653 13.4036 17.8848H14.4036ZM16.9988 24.4244C15.3893 22.7166 14.4036 20.4163 14.4036 17.8848H13.4036C13.4036 20.6813 14.4936 23.2242 16.271 25.1102L16.9988 24.4244ZM15.4977 30.298L17.1138 24.911L16.156 24.6237L14.5399 30.0106L15.4977 30.298ZM19.921 26.7563L14.7694 29.7209L15.2682 30.5877L20.4198 27.6231L19.921 26.7563ZM23.9407 27.4219C22.6727 27.4219 21.4637 27.1747 20.3583 26.7264L19.9825 27.653C21.2052 28.149 22.5417 28.4219 23.9407 28.4219V27.4219Z",
    fill: "#383434"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.3452,
    cy: 17.75,
    r: 1.01562,
    fill: "#383434"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.3765,
    cy: 17.75,
    r: 1.01562,
    fill: "#383434"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.4077,
    cy: 17.75,
    r: 1.01562,
    fill: "#383434"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.b376a5b9c79e3271db9301a20af64b94.svg";
export { ForwardRef as ReactComponent };